<template>
  <div class="file-uploader">
    <div v-if="message" class="alert alert-success">
      {{ message }}
    </div>

    <div v-if="error" class="alert alert-danger">
      {{ error }}
    </div>

    <form @submit.prevent="$emit('upload-files')">
      <div class="mb-3">
        <label for="files" class="form-label">
          Attachments Uploader
        </label>

        <div
          class="file-dropzone text-center p-4 border rounded"
          :class="{ 'is-dragover': isDragOver }"
          @click="$refs.fileInput.click()"
          @dragover.prevent="onDragOver"
          @dragleave.prevent="onDragLeave"
          @drop.prevent="onDrop"
        >
          <i class="far fa-cloud-upload fa-2x d-block mb-2"></i>
          Drop files here or browse to upload.
        </div>

        <input
          id="files"
          ref="fileInput"
          type="file"
          class="d-none"
          @change="handleFileChange"
          multiple
        >

        <small class="text-muted helper-text d-block mt-2">
          File maximum size is 10MB.
        </small>
      </div>

      <div v-for="(selectedFile, index) in selectedFiles" :key="`selectedFile-${index}`" class="mb-3">
        <strong>Selected:</strong> {{ selectedFile.name }}
      </div>

      <div v-if="uploading" class="mb-3">
        <div class="progress">
          <div
            class="progress-bar progress-bar-striped progress-bar-animated"
            role="progressbar"
            :style="{ width: uploadProgress + '%' }"
          >
            {{ uploadProgress }}%
          </div>
        </div>
      </div>

      <button
        type="submit"
        class="btn btn-primary"
        :disabled="!selectedFiles.length || uploading"
      >
        {{ uploading ? 'Uploading...' : 'Upload File' }}
      </button>
    </form>
  </div>
</template>

<script>
export default {
  props: {
    uploading: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: null
    },
  },
  data () {
    return {
      selectedFiles: [],
      files: [],
      loadingFiles: false,
      uploadProgress: 0,
      message: null,
      isDragOver: false,
    }
  },

  computed: {},

  methods: {
    handleFileChange (event) {
      const files = event.target.files || []
      this.setFiles(files)
    },

    onDragOver () {
      this.isDragOver = true
    },

    onDragLeave () {
      this.isDragOver = false
    },

    onDrop (event) {
      this.isDragOver = false

      const files = event.dataTransfer.files

      if (!files || !files.length) return

      this.setFiles(files)
    },

    setFiles (files) {
      if (!files || !files.length) return

      const maxSize = 10 * 1024 * 1024

      const fileSizes = [...files].map(file => file.size).reduce((sum, size) => sum + size, 0)

      if (fileSizes > maxSize) {
        alert('Files must be less than 10MB.')
        return
      }

      this.selectedFiles = files

      this.$emit('file-selected', files)
    },

    formatDate (date) {
      return new Date(date).toLocaleString()
    }
  }
}
</script>

<style scoped>

</style>
